import ENDPOINTS from '../../constants/apiEndPoints';
import {axiosInstance} from '../axiosInstance';

export const handleUploadImagesService = async (payload: FormData) => {
  try {
    const response = await axiosInstance.post(
      ENDPOINTS.UPLOAD_IMAGES,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return response.data;
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.errors?.join(`\n`) ||
      error?.response?.data?.message ||
      error?.message ||
      'Something went wrong';

    // Pass the status and message up for UI to handle
    throw {status: error?.response?.status, message: errorMessage};
  }
};

export const handleUploadVideosService = async (payload: FormData) => {
  try {
    const response = await axiosInstance.post(
      ENDPOINTS.UPLOAD_VIDEOS,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return response.data;
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.errors?.join(`\n`) ||
      error?.response?.data?.message ||
      error?.message ||
      'Something went wrong';

    // Pass the status and message up for UI to handle
    throw {status: error?.response?.status, message: errorMessage};
  }
};

export const handleUploadDocumentsService = async (payload: FormData) => {
  try {
    const response = await axiosInstance.post(ENDPOINTS.UPLOAD_FILES, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.errors?.join(`\n`) ||
      error?.response?.data?.message ||
      error?.message ||
      'Something went wrong';

    // Pass the status and message up for UI to handle
    throw {status: error?.response?.status, message: errorMessage};
  }
};
